<template>
  <WidgetCard title="Monitoring Portfolio" icon="desktop" :loading="loading" :error="error" :empty="emptyMessage">
    <template v-if="ready" #headerExtra>
      <div class="dw-headstat">
        <div class="dw-headstat__n">{{ data.total.toLocaleString() }}</div>
        <div class="dw-headstat__t">URLs</div>
      </div>
    </template>
    <template v-if="ready">
      <div class="dw-pie">
        <PieChart :chartData="chartData" :options="chartOptions" :styles="fillStyles" />
      </div>
      <div class="dw-pie-legend">
        <div v-for="g in segments" :key="g.status" class="dw-row">
          <span class="dw-row__dot" :style="{ background: g.color }" />
          <strong>{{ g.count.toLocaleString() }}</strong>
          <span class="dw-row__label" :title="g.label">{{ g.label }}</span>
        </div>
      </div>
      <div v-if="archived > 0" class="dw-note">
        {{ archived.toLocaleString() }} archived {{ archived === 1 ? 'URL' : 'URLs' }}, not monitored
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import PieChart from '@shared/components/PieChart';
  import { STATUS_COLOR } from '@constants/statusColor';

  export default {
    name: 'PortfolioWidget',
    components: { WidgetCard, PieChart },
    props: {
      data: { type: Object, default: null },
      // null when the count could not be determined — not the same as zero.
      archived: { type: Number, default: null },
      loading: { type: Boolean, default: false },
      error: { type: [Boolean, String], default: false }
    },
    data() {
      return {
        // Fill .dw-pie so the canvas is flex-sized (shrinks + grows).
        fillStyles: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' },
        chartOptions: {
          title: { display: false },
          legend: { display: false },
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: (item, chart) => {
                const label = chart.labels[item.index] || '';
                const value = chart.datasets[0].data[item.index] || 0;
                return `${label}: ${value}`;
              }
            }
          }
        }
      };
    },
    computed: {
      ready() {
        return !this.loading && !this.error && this.data && this.data.total > 0;
      },
      emptyMessage() {
        if (this.loading || this.error || (this.data && this.data.total > 0)) return '';
        return this.archived > 0
          ? `No monitored URLs — ${this.archived.toLocaleString()} archived`
          : 'No monitored URLs yet';
      },
      segments() {
        if (!this.data) return [];
        return this.data.groups.map((g) => ({
          ...g,
          label: g.status,
          color: STATUS_COLOR[g.status] || '#a9a9a9'
        }));
      },
      chartData() {
        return {
          labels: this.segments.map((g) => g.label),
          datasets: [
            {
              backgroundColor: this.segments.map((g) => g.color),
              borderWidth: 1,
              borderColor: '#ffffff',
              data: this.segments.map((g) => g.count)
            }
          ]
        };
      }
    }
  };
</script>
